module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "img-container"
  }, [_c('i', {
    staticClass: "icon code-icon image"
  }, [_vm._v("")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": _vm.qrcode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom-divide"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "company-name"
  }, [_vm._v("关注智慧食堂")]), _vm._v(" "), _c('div', {
    staticClass: "tip-color"
  }, [_vm._v("长按右边二维码")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-503f4ac5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/attention.vue
// module id = 847
// module chunks = 34